import { jsx as n, jsxs as c, Fragment as f } from "react/jsx-runtime";
import T, { useMemo as m } from "react";
import e from "./style.module.less.js";
import _ from "./social-fb.svg.js";
import q from "./social-instagram.svg.js";
import E from "./social-tik-tok.svg.js";
import F from "./social-youtube.svg.js";
import R from "./social-ln.svg.js";
import D from "./logo-white.webp.js";
import { CountryLanguageSelector as M } from "../country-language-selector/index.js";
import { DEFAULT_LANGUAGE_CODE as x, canLanguageUseAtticus as H, areasOfLawData as L, withDirectoryCountries as C, directoryBaseData as v } from "../../../constants.js";
import { convertToKebabCase as S } from "../../../utils/case-conversion.js";
import { getRoute as w, RouteType as I } from "../../../utils/get-route.js";
import W from "../menu/message-animated.svg.js";
import A from "../menu/spark-animated-midnight.svg.js";
import { useFeatureFlags as Y } from "../../../context/config-context.js";
const B = [
  {
    name: "Facebook",
    link: "https://www.facebook.com/asklawconnect",
    Icon: _
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/asklawconnect/",
    Icon: q
  },
  {
    name: "TikTok",
    link: "https://www.tiktok.com/@asklawconnect",
    Icon: E
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/company/lawconnect/",
    Icon: R
  },
  {
    name: "Youtube",
    link: "https://www.youtube.com/@asklawconnect",
    Icon: F
  }
], K = () => /* @__PURE__ */ n("div", { className: e.socialContainer, children: B.map((r) => /* @__PURE__ */ n(
  "a",
  {
    href: r.link,
    target: "_blank",
    rel: "noreferrer",
    "aria-label": r.name,
    className: e.socialIconContainer,
    children: /* @__PURE__ */ n(r.Icon, { width: 32, height: 32, className: e.socialIcon })
  },
  r.name
)) }), ce = (r) => {
  const {
    className: a = "",
    onLanguageChange: u,
    isAuthenticated: s,
    openAuthModal: d,
    language: o = x,
    getTranslation: i,
    isLawyerSupported: p,
    legalHubSupported: k,
    onRequestLawyer: N
  } = r, g = m(() => o === "en-au", [o]), y = m(() => H(o) ? o : void 0, [o]), $ = m(
    () => i("auth.copyright-terms-privacy").replace(/TERMS_LINK/g, o ? `/${o}/terms` : "/terms").replace(
      /PRIVACY_LINK/g,
      o ? `/${o}/privacy` : "/privacy"
    ),
    [i, o]
  ), t = m(() => o ? L[o] : null, [o]), h = /* @__PURE__ */ n(
    M,
    {
      onLanguageChange: u,
      language: o ?? ""
    }
  ), l = () => /* @__PURE__ */ n(
    "a",
    {
      href: "/account",
      className: `${e.menuItem}`,
      onClick: (b) => {
        s || (b.preventDefault(), d == null || d());
      },
      children: i("pages.account")
    }
  );
  return /* @__PURE__ */ n("footer", { className: `${e.footer} ${a}`, children: /* @__PURE__ */ c("div", { className: e.widthWrapper, children: [
    /* @__PURE__ */ c(
      "div",
      {
        className: `${e.logoContainer} ${t != null && t.length ? e.large : ""}`,
        children: [
          /* @__PURE__ */ n("a", { href: o ? `/${o}` : "/", className: e.logo, children: /* @__PURE__ */ n(
            "img",
            {
              src: D,
              width: 202,
              height: 28,
              alt: "LawConnect Logo",
              loading: "lazy",
              className: e.logoImage
            }
          ) }),
          /* @__PURE__ */ n("div", { className: e.headerLanguageSelector, children: h })
        ]
      }
    ),
    t != null && t.length ? /* @__PURE__ */ n("div", { className: `${e.gridContainer} ${e.large}`, children: /* @__PURE__ */ n(
      Q,
      {
        language: o,
        accountComponent: /* @__PURE__ */ n(l, {}),
        isLawyerSupported: p,
        onRequestLawyer: y ? N : void 0,
        isLegalMarketplaceEnabled: g,
        legalHubSupported: k
      }
    ) }) : /* @__PURE__ */ n("div", { className: e.gridContainer, children: /* @__PURE__ */ n(
      U,
      {
        language: o,
        accountComponent: /* @__PURE__ */ n(l, {}),
        getTranslation: i
      }
    ) }),
    /* @__PURE__ */ c("div", { className: e.bottomBarContainer, children: [
      /* @__PURE__ */ c("div", { className: e.bottomSocialContainer, children: [
        /* @__PURE__ */ n(K, {}),
        /* @__PURE__ */ n("div", { className: e.languageSelectorContainer, children: h })
      ] }),
      /* @__PURE__ */ c("div", { className: e.copyright, children: [
        /* @__PURE__ */ n("div", { children: i("auth.copyright").replace(
          "<YEAR>",
          (/* @__PURE__ */ new Date()).getFullYear().toString()
        ) }),
        /* @__PURE__ */ c("div", { className: e.copyrightBottom, children: [
          /* @__PURE__ */ c("div", { children: [
            i("auth.copyright-description"),
            " "
          ] }),
          t != null && t.length ? /* @__PURE__ */ n("div", { dangerouslySetInnerHTML: { __html: $ } }) : null,
          o === "en-au" && /* @__PURE__ */ c(f, { children: [
            /* @__PURE__ */ n("br", {}),
            /* @__PURE__ */ c("div", { className: e.sitemapLink, children: [
              " ",
              /* @__PURE__ */ n("a", { href: o ? `/${o}/sitemap` : "/sitemap", children: "Sitemap" }),
              "."
            ] })
          ] })
        ] })
      ] })
    ] })
  ] }) });
}, Q = (r) => {
  const {
    language: a,
    accountComponent: u,
    isLawyerSupported: s,
    isLegalMarketplaceEnabled: d,
    onRequestLawyer: o,
    legalHubSupported: i
  } = r, { diyWill: p } = Y(), k = m(() => {
    const t = L[a];
    return C.includes(a) ? [
      ...t,
      {
        title: v.footerTitle ?? "",
        description: v.description,
        image: v.image,
        link: "topics"
      }
    ] : t;
  }, [a]), N = m(() => C.includes(a), [a]), g = s ? 5 : 4, y = m(() => {
    const t = g * 2, h = k.slice(0, t);
    return [h.slice(0, g), h.slice(g)];
  }, [k, g]), $ = m(() => [
    {
      header: "Browse",
      items: [
        {
          key: "request",
          label: "Request a lawyer",
          href: o ? void 0 : w(I.LAWYER_REQUEST_CHAT),
          icon: /* @__PURE__ */ n(W, { className: e.menuIcon }),
          className: `${e.menuItem} ${e.requestLawyer}`,
          show: !!s,
          onClick: o
        },
        {
          key: "ask",
          label: "Ask a question",
          href: w(I.NEW_CHAT),
          icon: /* @__PURE__ */ n(A, { className: e.menuIcon }),
          className: `${e.menuItem} ${e.askQuestion}`
        },
        {
          key: "library",
          label: i ? "Legal hub" : "Legal topics",
          href: `/${a}/${i ? "legal-hub" : "topics"}`,
          className: e.menuItem
        },
        {
          key: "about",
          label: "About",
          href: s ? a ? `/${a}/about/company` : "/about/company" : a ? `/${a}/about` : "/about",
          className: e.menuItem
        },
        {
          key: "for-lawyers",
          label: "For lawyers",
          href: a ? `/${a}/for-lawyers/legal-network` : "/for-lawyers/legal-network",
          className: e.menuItem
        },
        {
          key: "account",
          node: u,
          show: !s
        }
      ]
    },
    {
      header: "",
      items: [
        {
          key: "make-will",
          label: "Make a will",
          href: w(I.WILL_INFO),
          className: e.menuItem,
          show: a === "en-us" && p === !0
        },
        {
          key: "find-a-lawyer",
          label: "Browse lawyers",
          href: a ? `/${a}/find` : "/find",
          className: e.menuItem,
          show: !!s && d
        },
        {
          key: "insights",
          label: "Insights",
          href: a ? `/${a}/insights` : "/insights",
          className: e.menuItem
        },
        {
          key: "faqs",
          label: "FAQs",
          href: a ? `/${a}/faqs` : "/faqs",
          className: e.menuItem
        },
        {
          key: "directory",
          label: "Case study directory",
          href: a ? `/${a}/directory` : "/directory",
          className: e.menuItem,
          show: N && !!s && !d
        },
        {
          key: "ai-technology",
          label: "Our AI technology",
          href: a ? `/${a}/about/ai-technology` : "/about/ai-technology",
          className: e.menuItem,
          show: !s && !(a === "en-us" && p === !0)
        },
        {
          key: "company",
          label: "Company",
          href: a ? `/${a}/about/company` : "/about/company",
          className: e.menuItem,
          show: !s
        },
        {
          key: "contact",
          label: "Contact us",
          href: a ? `/${a}/contact-us` : "/contact-us",
          className: e.menuItem
        },
        {
          key: "account",
          node: u,
          show: !!s
        }
      ]
    },
    {
      header: "Topics",
      items: y[0].map((t) => ({
        key: `area-1-${t.title}`,
        label: t.footerTitle ?? t.title,
        href: t.link === "topics" ? `/${a}/topics` : `/${a}/topics/${t.link ?? S(t.title)}`,
        className: e.menuItem
      }))
    },
    {
      header: "",
      items: y[1].map((t) => ({
        key: `area-2-${t.title}`,
        label: t.footerTitle ?? t.title,
        href: t.link === "topics" ? `/${a}/topics` : `/${a}/topics/${t.link ?? S(t.title)}`,
        className: e.menuItem
      }))
    }
  ], [
    a,
    s,
    N,
    y,
    u,
    p
  ]);
  return /* @__PURE__ */ n(f, { children: $.map((t, h) => /* @__PURE__ */ c("div", { className: e.column, children: [
    /* @__PURE__ */ n("div", { className: e.headerLabel, children: t.header ?? "" }),
    t.items.filter((l) => l.show !== !1).map(
      (l, b) => l.node ? /* @__PURE__ */ n(T.Fragment, { children: l.node }, `${l.key}-${b}`) : /* @__PURE__ */ n(
        "a",
        {
          href: l.href,
          className: l.className ?? e.menuItem,
          onClick: l.onClick,
          children: l.icon ? /* @__PURE__ */ c(f, { children: [
            /* @__PURE__ */ n("span", { className: e.menuItemText, children: l.label }),
            l.icon
          ] }) : /* @__PURE__ */ n(f, { children: l.label })
        },
        l.key
      )
    )
  ] }, h)) });
}, U = (r) => {
  const { language: a, accountComponent: u, getTranslation: s } = r;
  return /* @__PURE__ */ c(f, { children: [
    /* @__PURE__ */ c("div", { className: e.column, children: [
      /* @__PURE__ */ c(
        "a",
        {
          href: w(I.NEW_CHAT),
          className: `${e.menuItem} ${e.askQuestion}`,
          children: [
            s("pages.ask-a-question"),
            /* @__PURE__ */ n(A, { className: e.menuIcon })
          ]
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/about/company` : "/about/company",
          className: `${e.menuItem}`,
          children: s("pages.about")
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/for-lawyers/legal-network` : "/for-lawyers/legal-network",
          className: `${e.menuItem}`,
          children: s("register.for-lawyers")
        }
      )
    ] }),
    /* @__PURE__ */ c("div", { className: e.column, children: [
      a.includes("en") ? /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/insights` : "/insights",
          className: `${e.menuItem}`,
          children: s("pages.insights")
        }
      ) : null,
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/faqs` : "/faqs",
          className: `${e.menuItem}`,
          children: s("pages.faqs")
        }
      ),
      a.includes("en") ? null : /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/about/ai-technology` : "/about/ai-technology",
          className: `${e.menuItem}`,
          children: s("pages.ai-technology")
        }
      ),
      u
    ] }),
    /* @__PURE__ */ c("div", { className: e.column, children: [
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/contact-us` : "/contact-us",
          className: `${e.menuItem}`,
          children: s("pages.contact-us")
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/terms` : "/terms",
          className: `${e.menuItem}`,
          children: s("pages.terms")
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/privacy` : "/privacy",
          className: `${e.menuItem}`,
          children: s("pages.privacy-policy")
        }
      )
    ] })
  ] });
};
export {
  ce as FooterComponent,
  B as SOCIAL_MEDIA_LINKS
};
